/**
 * Returns true if url starts with https:// otherwise false
 * @param url
 * @returns true/false
 */
export default function isAbsoluteUrl(url: string | undefined): boolean {
  return url ? url.startsWith('https://') : false;
}
